"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ObjectSerializer";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
import Link from "next/link";
import Image from "next/image";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
interface SingleWaveDropAuthorProps {
  readonly drop: ApiDrop;
}
export const SingleWaveDropAuthor: React.FC<SingleWaveDropAuthorProps> = t0 => {
  const $ = _c(25);
  const {
    drop
  } = t0;
  const authorIdentity = drop.author.handle ?? drop.author.primary_address;
  let t1;
  if ($[0] !== drop.author.pfp) {
    t1 = drop.author.pfp ? resolveIpfsUrlSync(drop.author.pfp) : null;
    $[0] = drop.author.pfp;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resolvedPfp = t1;
  const avatarAlt = drop.author.handle ? `${drop.author.handle}'s profile picture` : "Profile picture";
  const t2 = `/${drop.author.handle ?? drop.author.primary_address}`;
  let t3;
  if ($[2] !== avatarAlt || $[3] !== resolvedPfp) {
    t3 = resolvedPfp ? <div className="tw-relative tw-h-10 tw-w-10 tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950"><Image src={resolvedPfp} alt={avatarAlt} fill={true} sizes="40px" className="tw-size-full tw-object-contain tw-opacity-90" /></div> : <div className="tw-h-10 tw-w-10 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-iron-900" />;
    $[2] = avatarAlt;
    $[3] = resolvedPfp;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== authorIdentity) {
    t4 = <span className="tw-text-md tw-font-semibold tw-text-white desktop-hover:hover:tw-text-opacity-80">{authorIdentity}</span>;
    $[5] = authorIdentity;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== authorIdentity || $[8] !== t4) {
    t5 = <UserProfileTooltipWrapper user={authorIdentity}>{t4}</UserProfileTooltipWrapper>;
    $[7] = authorIdentity;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop.author.level) {
    t6 = <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[10] = drop.author.level;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="tw-inline-flex tw-items-center tw-gap-x-1">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = `single-drop-author-badges-${drop.id}`;
  let t9;
  if ($[15] !== drop.author || $[16] !== t8) {
    t9 = <div className="tw-inline-flex tw-items-center tw-gap-x-1"><DropAuthorBadges profile={drop.author} tooltipIdPrefix={t8} /></div>;
    $[15] = drop.author;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <div className="tw-inline-flex tw-items-center tw-gap-x-2">{t7}{t9}</div>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2 || $[23] !== t3) {
    t11 = <div className="tw-flex tw-items-start tw-gap-x-2.5"><Link href={t2} className="tw-flex tw-items-center tw-gap-x-2.5 tw-no-underline">{t3}{t10}</Link></div>;
    $[21] = t10;
    $[22] = t2;
    $[23] = t3;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};